const tables = document.querySelectorAll('.rich-text table');

const wrapTable = el => {
    const wrappingElement = document.createElement('div');
    el.replaceWith(wrappingElement);
    wrappingElement.classList.add('overflow-x-auto');
    wrappingElement.appendChild(el);
}

tables.forEach(el => wrapTable(el));